import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import EarningsSubscriptionsChart from "./components/EarningsSubscriptionsChart";
import UserTable from "./components/UserTable";
import CandleChart from "./components/CandleChart";
import EarningsChart from "./components/BarChart";
import useCheckPermission from "../../../hooks/useCheckPermission";

const Dashboard = () => {
  const [timeFrame, setTimeFrame] = useState("7days");

  const handleTimeFrameChange = (e) => {
    setTimeFrame(e.target.value);
  };

  return (
    <>
      <section className="dashboard position-relative py-2">
        <Container>
          <Row>
            <Col lg="6" className="my-2">
              <EarningsSubscriptionsChart
                timeFrame={timeFrame}
                onTimeFrameChange={handleTimeFrameChange}
              />
            </Col>

            <Col lg="6" className="my-2">
              <div className="cardBox p-3 h-100">
                <EarningsChart />
              </div>
            </Col>
            {useCheckPermission("stockExchange", "VIEW") && (
              <Col lg="12" className="my-2">
                <div className="cardBox p-3 h-100">
                  <CandleChart />
                </div>
              </Col>
            )}
            {useCheckPermission("USER", "VIEW") && (
              <Col lg="12" className="my-5">
                <UserTable />
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
